import { render } from "./CardHeader.vue?vue&type=template&id=4bf2986b"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"
script.render = render

export default script